import React from 'react';
import { getComponentClasses } from '@99designs/frontend-components/utils/app/index';

// import './_range.scss';

interface Props {
    minLabel: string;
    maxLabel: string;
    min: number;
    max: number;
    value: number;
    variations?: string[];
}

function Range({ minLabel, maxLabel, min, max, value, variations = [] }: Props) {
    const valueAsPercentage = ((value - min) / (max - min)) * 100 + '%';

    return (
        <div className={getComponentClasses('range', variations)}>
            <div className="range__container">
                <div className="range__bar">
                    <div
                        className="range__handle"
                        style={{ left: valueAsPercentage }}
                        data-testid={'range-handle'}
                        role="slider"
                        aria-valuemin={min}
                        aria-valuemax={max}
                        aria-valuenow={value}
                        aria-readonly="true"
                        aria-label={`${minLabel} - ${maxLabel}`}
                    />
                </div>
                <div className="range__label range__label--min">{minLabel}</div>
                <div className="range__label range__label--max">{maxLabel}</div>
            </div>
        </div>
    );
}

export default Range;
